// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicy_container__dpZOW","header":"privacyPolicy_header__oYNE-","updatedDate":"privacyPolicy_updatedDate__o0gs0","list":"privacyPolicy_list__hVPYd"};